import { useState } from "react";
import { useNotify } from "react-admin";
import PrintIcon from "@mui/icons-material/Print";

import { settings } from "app";
import { erasmusRequests } from "api/erasmusApi";
import LoadingActionButton from "server/components/LoadingActionButton";
import { previewFileFromUrl } from "server/components/DownloadFile";

const CERTIFICATE_TYPES = {
  stay: {
    label: "Удостоверение за престой",
    getUrl: erasmusRequests.getIncomingEmployeeCertificateOfStay,
  },
  teaching: {
    label: "Удостоверение за преподаване",
    getUrl: erasmusRequests.getIncomingEmployeeCertificateOfTeaching,
  },
};

const GenerateCertificateButton = ({ id, type }) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { label, getUrl } = CERTIFICATE_TYPES[type];

  const handleClick = async () => {
    setLoading(true);

    // previewFileFromUrl notifies on failure itself and opens the pdf in a new tab on success
    const url = `${settings.gatewayApi}/${getUrl(id)}`;
    await previewFileFromUrl(url, label, notify);

    setLoading(false);
  };

  return (
    <LoadingActionButton
      label={label}
      icon={<PrintIcon />}
      onClick={handleClick}
      loading={loading}
      disabled={loading}
      width="auto"
      minWidth={220}
    />
  );
};

export default GenerateCertificateButton;
